document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;

  const lockBodyScroll = () => {
    body.classList.add('overflow-hidden-body');
  };

  const unlockBodyScroll = () => {
    const anyOpen = document.querySelector('.JSwebinarPopup.webinar-card__popup--active');
    if (!anyOpen) body.classList.remove('overflow-hidden-body');
  };

  const setHiddenFieldsFromModal = (modal) => {
    if (!modal) return;

    const form = modal.querySelector('form.wpcf7-form');
    if (!form) return;

    const title = modal.dataset.webinarTitle || '';
    const date = modal.dataset.webinarDate || '';
    const time = modal.dataset.webinarTime || '';

    const setVal = (name, value) => {
      const input = form.querySelector(`[name="${name}"]`);
      if (input) input.value = value;
    };

    setVal('webinar_title', title);
    setVal('webinar_date', date);
    setVal('webinar_time', time);
  };

  const openModal = (modal) => {
    const bg = modal.closest('.webinar-card__popup-background');
    if (bg) bg.classList.add('is-visible');

    modal.classList.add('webinar-card__popup--active');
    modal.setAttribute('aria-hidden', 'false');

    lockBodyScroll();
    setHiddenFieldsFromModal(modal);
  };

  const closeModal = (modal) => {
    const bg = modal.closest('.webinar-card__popup-background');

    modal.classList.remove('webinar-card__popup--active');
    modal.setAttribute('aria-hidden', 'true');

    if (bg) bg.classList.remove('is-visible');

    unlockBodyScroll();
  };

  document.querySelectorAll('.JSOpenWebinarModal').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();

      const modalId = btn.getAttribute('aria-controls');
      const modal = modalId ? document.getElementById(modalId) : null;
      if (!modal) return;

      openModal(modal);
    });
  });

  document.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('.JSWebinarX');
    if (closeBtn) {
      const modal = closeBtn.closest('.JSwebinarPopup');
      if (modal) closeModal(modal);
      return;
    }

    const bg = e.target.closest('.JSPopupBackground');
    if (bg && e.target === bg) {
      const modal = bg.querySelector('.JSwebinarPopup');
      if (modal) closeModal(modal);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const modal = document.querySelector('.JSwebinarPopup.webinar-card__popup--active');
    if (modal) closeModal(modal);
  });
});